import { BrowserRouter, Routes, Route, Outlet, useLocation, Link } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/i18n";
import { AdminAuthProvider } from "@/context/AdminAuth";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";
import CookieBanner from "@/components/site/CookieBanner";
import Home from "@/pages/Home";
import DestinationPage from "@/pages/DestinationPage";
import ServicePage from "@/pages/ServicePage";
import Eligibility from "@/pages/Eligibility";
import About from "@/pages/About";
import { Insights, Article } from "@/pages/Insights";
import FAQPage from "@/pages/FAQPage";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import { AdminLogin, AuthCallback } from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

const PublicLayout = () => (
  <>
    <SmoothScroll />
    <Navbar />
    <main id="main"><Outlet /></main>
    <Footer />
    <FloatingActions />
    <CookieBanner />
  </>
);

const NotFound = () => (
  <section className="flex min-h-[80vh] flex-col items-center justify-center bg-navy px-6 pt-32 text-center text-ivory" data-testid="not-found">
    <p className="eyebrow-light">404</p>
    <h1 className="h-display mt-6 text-5xl md:text-7xl">This page has moved on.</h1>
    <Link to="/" className="btn-gold mt-10"><span>Return home</span></Link>
  </section>
);

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/destinations/:slug" element={<DestinationPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/eligibility" element={<Eligibility />} />
        <Route path="/about" element={<About />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<Article />} />
        <Route path="/faq" element={<FAQPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Legal />} />
        <Route path="/terms" element={<Legal />} />
        <Route path="/disclaimer" element={<Legal />} />
        <Route path="*" element={<NotFound />} />
      </Route>
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <I18nProvider>
        <BrowserRouter>
          <AdminAuthProvider>
            <AppRoutes />
            <Toaster position="top-center" />
          </AdminAuthProvider>
        </BrowserRouter>
      </I18nProvider>
    </HelmetProvider>
  );
}
